/* eslint-disable no-console */
import { useEffect, useContext, useState, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import WsContext from 'contexts/wsContext';
import { useDeviceDetect, useVideoContext, useVideoRoomState } from 'hooks';
import { roomStates } from 'const';

export default (sessionToken, sessionId, accountId) => {
  const { t } = useTranslation('labels');
  const { isMobile } = useDeviceDetect();
  const queryClient = useQueryClient();
  const cable = useContext(WsContext);
  const toastId = useRef(null);
  const chatMessageNotificationRef = useRef(null);

  const { setMobileChatOpened, isMobileChatOpened } = useVideoContext();
  const roomState = useVideoRoomState();

  const [channel, setChannel] = useState(null);

  useEffect(() => {
    chatMessageNotificationRef.current = (sender) => {
      if (isMobile && !isMobileChatOpened && sender.id !== accountId && roomState === roomStates.connected) {
        toast.dismiss(toastId.current);
        toastId.current = toast.info(t('user_sent_a_new_message', { user: sender }), {
          onClick: () => setMobileChatOpened(true),
          autoClose: 3000,
        });
      }
    };
  }, [roomState, isMobileChatOpened, accountId, isMobile]);

  useEffect(() => {
    if (cable.subscriptions.subscriptions.length > 1 || !sessionToken || !sessionId || !accountId) return;
    const data = {
      channel: `VideoCallChannel`,
      session_id: sessionId,
      token_id: sessionToken,
      account_id: accountId,
    };
    const newChannel = cable.subscriptions.create(data, {
      received: (message) => {
        if (message.messages) {
          queryClient.invalidateQueries([
            'GET',
            `/apis/v2/direct_video_session_tokens/conversation`,
            { headers: { 'Adracare-Session-Token': sessionToken, 'Adracare-Session-Id': sessionId } },
          ]);
          const senderId = message.messages.data.attributes.sender_id;
          const sender = message.messages.data.attributes.accounts.filter(({ id }) => id === senderId)[0];
          if (chatMessageNotificationRef.current) {
            chatMessageNotificationRef.current(sender?.full_name || sender?.email || '');
          }
        } else if (message.online_status || message.name_change) {
          queryClient.invalidateQueries(['GET', `/apis/v2/video_session_tokens/${sessionToken}`, {}]);
          queryClient.invalidateQueries(['POST', `/apis/v2/direct_video_session_tokens`]);
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey[0] === 'POST' && query.queryKey[1] === `/apis/v2/direct_video_session_tokens`,
          });
        } else {
          console.log('VideoCallChannel Message !!!:', message);
        }
      },
    });

    setChannel(newChannel);

    return () => {
      if (channel && channel.unsubscribe) channel.unsubscribe();
    };
  }, [sessionToken, sessionId, accountId]);

  return {};
};
